import React, { useState } from "react";
import Swal from "sweetalert2";
import { useForm } from "../../hooks/useForm";
import { UrlWs } from "../../utils/Global";
import { PlaceholderTabla } from "../Otros/Placeholder";
import { BuscarParticipante } from "../Participantes/BuscarParticipante";

export const ExcluirFuncionario = ({ setUpdateProceso, idProcess }) => {
  const [cargandoDatosExcluir, setCargandoDatosExcluir] = useState(false);
  const [cargandoDatosBuscar, setCargandoDatosBuscar] = useState(false);
  const [participante, setParticipante] = useState(null);
  const [{ motivo }, handleInputChange, resetForm] = useForm({ motivo: "" });

  const excluirFuncionario = async () => {
    if (cargandoDatosExcluir === false) {
      setCargandoDatosExcluir(true);
      const url =UrlWs+
        "/participants";
      await fetch(url, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id_participant: participante.id_participant,
          status: false,
          commentExclusion: motivo,
        }),
      }).then((response) => {
        const respuesta = response.json();
        if (response.status == 200) {
          setCargandoDatosExcluir(false);
          setUpdateProceso(true);
          const $ = window.jQuery;
          $("#m-excluir-funcionario").modal("hide");
          resetForm();
          setParticipante(null);
          Swal.fire({
            title: "Listo",
            text: "Participante excluído",
            icon: "success",
            confirmButtonText: "Ok",
          });
        } else {
          Swal.fire({
            title: "Error",
            text: respuesta.errors ?? "Ocurrió un error",
            icon: "error",
            confirmButtonText: "Ok",
          });
        }
      });
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-lg-4">
          <BuscarParticipante
            setParticipante={setParticipante}
            idProcess={idProcess}
            setCargando={setCargandoDatosBuscar}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <span className="fw-bolder fs-5 mb-5">&nbsp;</span>
          {participante === null && cargandoDatosBuscar === false ? (
            <></>
          ) : cargandoDatosBuscar === true ? (
            <PlaceholderTabla filas={1}></PlaceholderTabla>
          ) : (
            <div className="table-responsive">
              <table className="table table-rounded table-striped border gy-7 gs-7">
                <thead>
                  <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
                    <th>Nombre</th>
                    <th>Rut</th>
                    <th>Profesión</th>
                  </tr>
                </thead>
                <tbody>
                  {participante != null ? (
                    <tr>
                      <td>{participante.officerName}</td>
                      <td>{participante.officerRut}</td>
                      <td>{participante.profession}</td>
                    </tr>
                  ) : (
                    <tr>
                      <td colSpan={3}></td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
        <div className="col-md-12 mt-4">
          <label>Motivo de exclusión</label>
          <textarea
            name="motivo"
            value={motivo}
            id="motivo"
            onChange={handleInputChange}
            className="form-control mb-8"
            rows="2"
            placeholder="Indique el motivo de la exclusión del participante"
          ></textarea>
        </div>
      </div>

      <div className="d-flex justify-content-end">
        <button
          type="button"
          onClick={excluirFuncionario}
          className="btn btn-sm btn-primary px-6"
        >
          {cargandoDatosExcluir
            ? " Excluyendo participante..."
            : " excluir"}
        </button>
      </div>
    </>
  );
};
